import { render, staticRenderFns } from "./Protrain.vue?vue&type=template&id=007d1292"
import script from "./Protrain.vue?vue&type=script&lang=js"
export * from "./Protrain.vue?vue&type=script&lang=js"
import style0 from "./Protrain.vue?vue&type=style&index=0&id=007d1292&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports